module.exports = __webpack_public_path__ + "media/images/icons/filled/file-exclamation-08e1fed44c0cca18c24d396f847388ee.svg";